import axios from '@/libs/api.request'

/**
 * 解绑设备
 */
export const unBind = (id) => {
    const data ={
        "id": id
    }
    return axios.request({
        url: '/api/admin/mdhz/unBind',
        data,
        method: 'post'
    })
}
